class ImagePreview {
    element;
    filename;

    constructor({src, filename = ''}) {
        this.src = src;
        this.filename = filename;

        this.show = this.show.bind(this);
        this.render = this.render.bind(this);
        this.destroy = this.destroy.bind(this);
        this.ignoreClick = this.ignoreClick.bind(this);
        this.getDOMElement = this.getDOMElement.bind(this);

        this.show();
    }

    getDOMElement = () => {
        if (!this.element) {
            this.element = this.render();
        }

        return this.element;
    }

    render() {
        const element = document.createElement('div');
        element.classList.add('upload-image-preview-overlay');
        element.innerHTML = `
        <img class="file-input-full-image" alt="${this.filename || 'Uploaded file'}" src="${this.src}"/>
        <span class="full-image-icon close-zoom-image-icon badge badge-danger round"><i class="fa fa-times"></i></span>
`;

        element.addEventListener('click', this.handleCloseClick);

        element.querySelector('.close-zoom-image-icon').addEventListener('click', this.handleCloseClick);
        element.querySelector('img.file-input-full-image').addEventListener('click', this.ignoreClick);

        document.body.appendChild(element);

        return element;
    }

    show() {
        const element = this.getDOMElement();

        setTimeout(() => {
            element.classList.add('show')
        }, 100);
    }

    ignoreClick = event => {
        event.stopPropagation();
    }

    handleCloseClick = event => {
        this.destroy();
    }


    destroy() {
        const element = this.getDOMElement();
        element.classList.remove('show');

        setTimeout(() => {
            this.element.remove();
        }, 300);
    }
}

export default ImagePreview;
